import React, { useState, useEffect } from 'react'
import "./ScrollIndicator.css";

function ScrollIndicator({targetRef, count, offset}) {

    const [active, setActive] = useState(0);
    
    const onTargetScroll = (e) => {
        setActive(Math.round(targetRef.current.scrollLeft/offset))
    }

    useEffect(() => {
        targetRef.current.addEventListener('scroll', onTargetScroll);
    }, [offset])

    return (
        <ul className="scroll-indicator">
            {
                [...Array(count > 0 ? count : 1)].map((_, i) => (
                    <li 
                        key={i}
                        className={`indicator ${active === i? "active": ""}`}
                        onClick={() => targetRef.current.scrollTo(i* offset, 0)}
                    >
                        {i + 1}
                    </li>
                ))
            }
        </ul>
    )
}

export default ScrollIndicator;
